export const REACT_APP_NCLUDE_API = process.env.REACT_APP_NCLUDE_API;

export const GET_NEWS_BULLETIN_LIST = REACT_APP_NCLUDE_API + '/v1/api/news/get-news-bulletin-list';
export const GET_NEWS_BULLETIN = REACT_APP_NCLUDE_API + '/v1/api/news/get-news-bulletin';


